module.exports = __webpack_public_path__ + "media/images/publish-empty-6946e1c04cfd8356601deef5182b3666.png";